import { lazy } from 'react'
import i18n from 'common/i18n'
import { lazyRetry } from '../help/utils'

const Home = lazy(() => lazyRetry(() => import('containers/Home')))

const route = [
  {
    name: i18n.t('routes.home'),
    path: '/',
    main: Home,
    exact: true
  }
]

export default route
